import slugify from 'slugify'

export const stringToSlug = (str: string): string =>
  slugify(str, {
    lower: true,
    strict: true,
  })
